import { useTranslation } from 'react-i18next'

export const useLocalizedTariffName = () => {
  const { t } = useTranslation()
  
  return (tariffType: string) => {
    return t(`tariffs.${tariffType}`)
  }
}